import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// 组件
import { Page, Card, Tabs, Banner, Icon, BlockStack, Text } from '@shopify/polaris';
import OrganicKeywords from './components/OrganicKeywords';
import PaidKeywords from './components/PaidKeywords';
import { createBrowserHistory } from 'history';
// 样式+图标
import { ChevronLeftMinor } from "@shopify/polaris-icons";
import './index.css';
//翻译包
import Language from '../../../i18n/Language';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language

const history = createBrowserHistory() // history模式

class indexClass extends Component {

  state = {
    //选中tabs
    selected: 0,

    showBanner: true,

    //organic id
    oid: this.props.location.state ? this.props.location.state.oid : undefined,

    //paid id
    pid: this.props.location.state ? this.props.location.state.pid : undefined,
    webTitle: this.props.location.state ? this.props.location.state.title : undefined,
    //selectedType
    selectedType: this.props.location.state ? this.props.location.state.selectedType : 0,

    userServices: '',

    level: this.props.level,
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps.userServices !== this.props.userServices) {
      this.setState({
        userServices: nextProps.userServices
      })
    }

    if (nextProps.level !== this.props.level) {
      this.setState({
        level: nextProps.level
      })
    }
    return true;
  }

  componentDidMount() {
    this.setState({
      selected: this.state.selectedType === 0 ? 0 : 1,
    })
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState({
      selected: selectedTabIndex,
    });
  };

  bannerStatus = () => {
    this.setState({
      showBanner: false
    })
  }

  goBack = () => {
    history.go(-1)
  }

  render() {
    const {
      state: {
        selected,
        showBanner,
        oid,
        pid,
        webTitle,
        level,
      },
      handleTabChange,
      bannerStatus,
      goBack,
    } = this;

    let tableContent = ""
    if (selected === 0) {
      tableContent = <OrganicKeywords level={level} show={this.props.show} userServices={this.props.userServices} toggleToast={this.props.toggleToast} id={oid} />
    } else if (selected === 1) {
      tableContent = <PaidKeywords level={level} show={this.props.show} userServices={this.props.userServices} toggleToast={this.props.toggleToast} id={pid} />
    }

    const pageBanner = showBanner ? <div className='CompetitorKeywordsBanner'>
      <Banner
        title={t("After adding URLs, the system will complete the analysis within 24 hours.")}
        tone="info"
        onDismiss={bannerStatus}
      />
    </div> : ''

    const back = <div onClick={goBack} className='KeywordDetailReturn' style={{ display: 'flex', cursor: 'pointer' }}>
      <div><Icon source={ChevronLeftMinor} color="#5C5F62" /></div>
      <Text variant="headingMd" as="h2">{webTitle}</Text>
    </div>

    const pagesContent = <div className='KeywordsLibraryContent'>
      {tableContent}
    </div>;

    const tabs = [
      {
        id: "organic-keywords",
        content: t("Organic keywords"),
        accessibilityLabel: "All customers",
        panelID: "organic-keywords-content",
      },
      {
        id: "paid-keywords",
        content: t("Paid keywords"),
        panelID: "paid-keywords-content",
      },
    ];

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    return (
      <div>
        <Page
        // fullWidth
        // title={<div style={{ display: "flex", alignItems: "center"}}>
        //   {t("Competitor Keywords Research")}&nbsp;
        //   <Tooltip content={t("Analyze your competitors' keywords and identify content gaps to enhance your SEO content strategy.")}>
        //     {<Icon backdrop source={QuestionMarkInverseMajor} />}
        //   </Tooltip>
        // </div>}
        >

          <title>SEOAnt - Competitor Keywords Research</title>
          {pageBanner}
          {back}
          <div className='KeywordsLibrary'>
            <Card padding={0}>
              <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}></Tabs>
              {pagesContent}
            </Card>
          </div>

          {/* 底部 */}
          {FooterHelpBox}
        </Page>
      </div>
    );
  }
}

// export default indexClass;
export default withRouter(indexClass);
